import { KeyLabelType, Nullable } from '~/types'
import api from '../../api/http-common'
import { AxiosResponse } from 'axios'

const getCO2FootprintsOptions = (data?) =>
  api.post('/co2-footprints/get-index-data', data)

const getCO2Footprints = (data?) =>
  api.post('/co2-footprints/index', data)

const getCO2Count = (data?) =>
  api.post('/co2-footprints/count', data)

const getCO2CountActive = () =>
  api.post('/co2-footprints/count-active')

const getCO2OptionsData = () =>
  api.post('/co2-footprints/get-options-data')

const createCO2Footprint = (data?) =>
  api.post('/co2-footprints/store', data)

const getCO2Footprint = (id: string) =>
  api.post(`/co2-footprints/${id}/edit`)

const planCO2 = (id: string) =>
  api.post(`/co2-footprints/${id}/plan`)

const deleteCO2FootPrint = (id: string) =>
  api.post(`/co2-footprints/${id}/delete`)

const updateCO2Footprint = (id: string, data) =>
  api.post(`/co2-footprints/${id}/update`, data)

const getCO2AnswerOptions = (id: string, data?): ApiClientReturnType<CO2OptionsType> =>
  api.post(`co2-footprints/${id}/answer/get-options-data`, data)

const storeCO2Answers = (id: string, data) =>
  api.post(`co2-footprints/${id}/answer/store`, data)

const getCO2Results = (id: string, data) =>
  api.post(`co2-footprints/${id}/answer/get-results`, data)

const getPredefinedData = (id: string, data: any) =>
  api.post(`co2-footprints/${id}/answer/get-predefined-data`, data)

const getCO2SubmitData = (id: string, data?) =>
  api.post(`co2-footprints/${id}/get-results`, data)

const getCO2ShowData = (id: string) =>
  api.post(`co2-footprints/${id}/show`)

const getCO2AnswerData = (id: string, data?) =>
  api.post(`co2-footprints/${id}/answer/edit`, data)

const getCO2FarmerGroups = (id: string, data) =>
  api.post(`co2-footprints/${id}/farmer-groups/index`, data)

const getCO2Farmers = (id: string, data) =>
  api.post(`co2-footprints/${id}/farmers/index`, data)

const getCO2List = () =>
  api.post('co2-footprints/list')

const getCo2File = (id: string, data: any) =>
  api.post(`co2-footprints/${id}/get-file`, data)

const deleteCo2File = (id: string, data: any) =>
  api.post(`co2-footprints/${id}/delete-file`, data)

const getCO2FarmerResults = (id: string, idFarmer: string) =>
  api.post(`co2-footprints/${id}/farmers/${idFarmer}/get-results`)

const getEnergyData = (id: string, data): ApiClientReturnType<Co2EnergyDataType> =>
  api.post(`/co2-footprints/${id}/answer/get-energy-data`, data)

const calculateEnergyData = (id: string, data) =>
  api.post(`/co2-footprints/${id}/answer/calculate-energy-addition`, data)

const getCo2PreviewFile = (id: string) =>
  api.post(`/co2-footprints/${id}/get-file`)

const noShowCheckedSave = (id: string, data?) =>
  api.post(`/co2-footprints/${id}/answer/disable-file-preview`, data)

const co2Farmers = (id: string, data) =>
  api.post(`/co2-footprints/${id}/farmers/index`, data)

const saveCo2Draft = (id: string, data) =>
  api.post(`/co2-footprints/${id}/answer/save`, data)

const checkCo2Status = (id: string, data?) =>
  api.post(`/co2-footprints/${id}/answer/check`, data)

const getCo2Settings = () =>
  api.post('settings/co2-footprint/edit')

const updateCo2Settings = (data: any) =>
  api.post('settings/co2-footprint/update', data)

const getFarmerGroupsList = (data: any) =>
  api.post('/farmer-groups/co2/list', data)

const CO2Service = {
  getCO2FootprintsOptions,
  getCO2Footprints,
  getCO2Count,
  getCO2CountActive,
  getCO2OptionsData,
  getCO2Footprint,
  createCO2Footprint,
  updateCO2Footprint,
  planCO2,
  deleteCO2FootPrint,
  getCO2AnswerOptions,
  storeCO2Answers,
  getCO2Results,
  getPredefinedData,
  getCO2SubmitData,
  getCO2ShowData,
  getCO2FarmerGroups,
  getCO2Farmers,
  getCO2FarmerResults,
  getCO2AnswerData,
  getCO2List,
  getCo2File,
  deleteCo2File,
  getEnergyData,
  calculateEnergyData,
  getCo2PreviewFile,
  noShowCheckedSave,
  co2Farmers,
  saveCo2Draft,
  checkCo2Status,
  getCo2Settings,
  updateCo2Settings,
  getFarmerGroupsList
}

export default CO2Service

type FarmerAmountType = {
  id: string | number,
  month: string,
  amount: string | number,
  fat: string | number,
  protein: string | number,
  netPrice: string | number
}

type FarmerType = {
  id: string;
  companyName: string;
  supplierNo: string;
  streetName: string;
  streetNumber: string;
  zip: string;
  taxation?: string;
  city: string;
  amounts?: FarmerAmountType[];
  countryId: number;
  district: null;
  name: string;
  iso: string;
  phoneCode: string;
  order: number;
  stateName: string;
  label: string;
  districtName: string;
  districtNumber: string;
  saleTaxLabel: string;
  totalMilkAmount?: Nullable<string | number>
  fat?: Nullable<string | number>
  protein?: Nullable<string | number>
  milkPrice?: Nullable<string | number>
  ureaContent?: Nullable<string | number>
}
export interface CO2OptionsType {
  breeds: { id: number, label: string }[];
  manureTypes: KeyLabelType[];
  calfRearingTypes: KeyLabelType[];
  manureStorageTypes: CoarseFeed[];
  energyConsumptions: CoarseFeed[];
  concentratedFeeds: ConcentratedFeeds;
  filePreview: boolean;
  juicyFeeds: CoarseFeed[];
  coarseFeeds: CoarseFeed[];
  farmer: FarmerType
  co2Footprint: {
    periodFrom: string
    periodTo: string
    status: '',
    end: string
  }
  taxes: KeyLabelType[]
  housingTypes: KeyLabelType[]
  useMilkPrice: number
}

export interface CoarseFeed {
  id: number;
  slug: string;
  label: string;
}

export interface ConcentratedFeeds {
  Eiweißkraftfutter: Futter[];
  Energiekraftfutter: Futter[];
  'Sonstige und Mineralfutter': Futter[];
}

export interface Futter {
  id: number;
  slug: string;
  group: number;
  label: string;
  groupLabel: GroupLabel;
}

export enum GroupLabel {
  Eiweißkraftfutter = 'Eiweißkraftfutter',
  Energiekraftfutter = 'Energiekraftfutter',
  SonstigeUndMineralfutter = 'Sonstige und Mineralfutter',
}

export type Co2EnergyDataType = {
  maintenanceNeedsEnergy: number
  powerRequirementEnergy: number
  reproductionNeedsEnergy: number
  totalEnergy: number
}

type ApiClientReturnType<T> = Promise<AxiosResponse<T>>;